<!-- <div class="container"> -->
  <h2 mat-dialog-title class="switch-account-header w-full">Join Club</h2>
  <mat-dialog-content class="switch-account-detail w-full flex">
    <hr class="custom-hr" />
    <p class="switch-account-message">
      With one click, you activate a permanent KingClub membership, filled with
      rewards and benefits that are yours for life.
    </p>
  </mat-dialog-content>
  <mat-dialog-actions class="switch-account-actions flex w-full">
    <button matButton mat-dialog-close class="cancel-switch-account" (click)="cancel()">Cancel</button>
    @if (isLoggedIn | async) {
      <button
        matButton
        class="button flex w-full switch-account-button"
        (click)="switchAccount()"
        >
        <span>Yes, I'm Sure</span>
      </button>
    } @else {
      <button
        matButton
        class="button flex w-full switch-account-button"
        (click)="loginToJoin()"
        >
        <span>Login To Join</span>
      </button>
    }
  </mat-dialog-actions>
<!-- </div> -->
